import { createStore, combineReducers, compose } from 'redux';
import behavior from './reducers/behaviorReducer';
import messages from './reducers/messagesReducer';
import quickButtons from './reducers/quickButtonsReducer';
import preview from './reducers/fullscreenPreviewReducer';

// Determine composeEnhancers based on environment and availability of Redux DevTools extension
const composeEnhancers =
  process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

// Combine reducers into a single rootReducer
const rootReducer = combineReducers({
  behavior: behavior,
  messages: messages,
  quickButtons: quickButtons,
  preview: preview
});

// Create the Redux store
const store = createStore(rootReducer, composeEnhancers());

export default store;
